module.exports = __webpack_public_path__ + "img/walahar.aeafafb2.svg";